export default (dateSet, array, conversion, format) => {
  dateSet.forEach((date) => {
    let dateExists = array?.[date]
    dateExists && (array[date] = conversion(array[date], format))
  })
}
